/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import searchIcon from '../../../../assets/images/Fireboard/search_black.png';
import classes from './SearchInput.module.css';

const SearchInput = ({ onSearch, onToggleSearchInput }) => {
  const [searchedValue, setSearchedValue] = useState('');

  const onChangeInput = e => {
    const value = e.target.value;
    setSearchedValue(value);
  };

  const searchHandler = () => {
    onSearch(searchedValue);
  };

  return (
    <div className={classes.container}>
      <input
        type={'text'}
        placeholder={'To search type here'}
        value={searchedValue}
        onChange={onChangeInput}
        className={classes.input}
      />
      <Button className={classes.searchBtn} onClick={searchHandler}>
        <img src={searchIcon} className={classes.searchIcon} alt='search' />
      </Button>
      <Button className={classes.closeBtn} onClick={() => onToggleSearchInput(false)}>
        X
      </Button>
    </div>
  );
};

export default SearchInput;

SearchInput.propTypes = {
  onSearch: PropTypes.func,
  onToggleSearchInput: PropTypes.func,
};

SearchInput.defaultProps = {
  onSearch: () => { },
  onToggleSearchInput: () => { }
};
